import React from 'react';

import SvgContainer from '../SvgContainer';

const CircleCheck = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100944)">
                <path d="M12.238 5.03401C11.9257 4.71953 11.4174 4.71863 11.104 5.032L6.4 9.736L4.09239 7.43482C3.78056 7.12386 3.27579 7.12421 2.96439 7.43561C2.65269 7.74731 2.65269 8.25269 2.96439 8.56439L5.69289 11.2929C6.08342 11.6834 6.71658 11.6834 7.10711 11.2929L12.236 6.164C12.5478 5.85219 12.5487 5.34692 12.238 5.03401ZM8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8 14.4C4.464 14.4 1.6 11.536 1.6 8C1.6 4.464 4.464 1.6 8 1.6C11.536 1.6 14.4 4.464 14.4 8C14.4 11.536 11.536 14.4 8 14.4Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100944">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default CircleCheck;
